import { ReceivedInvoiceDetail } from '@/context/services/invoice/type';
import { Ratio } from '@/features/invoices/components/Details/Components/Content/Ratio';
import { Split } from '@/features/invoices/components/Details/Components/Content/Split';
import { FC, memo } from 'react';

export type Props = {
  splitView: boolean;
  data: ReceivedInvoiceDetail;
};

export const Content: FC<Props> = memo(({ splitView, data }) => {
  return splitView ? <Split data={data} /> : <Ratio data={data} />;
});
Content.displayName = 'Content';
